import React, { useState } from "react";
import { HiOutlineLink } from "react-icons/hi2";
import { IoShareOutline, IoCopyOutline } from "react-icons/io5";
import { createInvitation } from "../../services/workspace-management";

export default function WorkspaceInvitation({ ws, hasPermission }) {
  const [expiration, setExpiration] = useState("24");
  const [inviteCode, setInviteCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [generating, setGenerating] = useState(false);

  const generateCode = async () => {
    setGenerating(true);
    setInviteCode("");
    try {
      const expiresAt =
        expiration === "0"
          ? Date.now() + 365 * 24 * 3600000 * 10
          : Date.now() + parseInt(expiration) * 3600000;
      const data = await createInvitation(ws._id, expiresAt);
      if (data.invitation?.token) {
        setInviteCode(data.invitation.token);
      } else {
        alert(data.msg || "Erreur lors de la génération du code.");
      }
    } catch {
      alert("Erreur réseau.");
    } finally {
      setGenerating(false);
    }
  };

  const copyCode = () => {
    if (inviteCode) {
      navigator.clipboard.writeText(inviteCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <HiOutlineLink size={20} />
        <h5 className="mb-0">Inviter des membres</h5>
      </div>
      <div className="card-body p-4">
        {hasPermission("CREATE_WORKSPACE_INVITATION") ? (
          <>
            <div className="mb-3">
              <label className="form-label">
                Code d'invitation valable
              </label>
              <div className="d-flex gap-2">
                <select
                  className="form-select"
                  value={expiration}
                  onChange={(e) => setExpiration(e.target.value)}
                >
                  <option value="1">1 heure</option>
                  <option value="6">6 heures</option>
                  <option value="24">24 heures</option>
                  <option value="72">3 jours</option>
                  <option value="168">7 jours</option>
                  <option value="720">30 jours</option>
                  <option value="0">Jamais</option>
                </select>
                <button
                  className="btn btn-primary"
                  onClick={generateCode}
                  disabled={generating}
                >
                  {generating ? (
                    <span className="spinner-border spinner-border-sm me-1" />
                  ) : (
                    <IoShareOutline className="me-1" />
                  )}
                  {generating ? "Génération..." : "Générer"}
                </button>
              </div>
            </div>

            {inviteCode && (
              <div className="mt-3 text-center">
                <p className="text-muted mb-2 small">
                  Partagez ce code pour inviter un membre
                </p>
                <div
                  className="d-inline-flex align-items-center gap-3 p-3 rounded-3 mb-2"
                  style={{
                    background: "#f8f9fa",
                    border: "2px dashed #dee2e6",
                  }}
                >
                  <span
                    className="fw-bold text-uppercase"
                    style={{
                      fontSize: "1.6rem",
                      letterSpacing: "0.25em",
                      fontFamily: "monospace",
                      color: "#212529",
                    }}
                  >
                    {inviteCode}
                  </span>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={copyCode}
                    title="Copier le code"
                  >
                    {copied ? (
                      <span className="text-success fw-semibold">Copié!</span>
                    ) : (
                      <IoCopyOutline />
                    )}
                  </button>
                </div>
                <div className="mt-2">
                  <small className="text-muted">
                    Le code expire{' '}
                    {expiration === "0"
                      ? "jamais"
                      : `dans ${expiration}h`}
                  </small>
                </div>
              </div>
            )}
          </>
        ) : (
          <p className="text-muted mb-0">
            Vous n'avez pas la permission de créer des invitations.
          </p>
        )}
      </div>
    </div>
  );
}
